// Registered FontAwesome icon ids. Filename in src/assets/icons/<name>.svg must match.
// Add new entries here as more icons get exported (see docs/fontawesome-icon-mapping.md).
export const ICON_NAMES = [
  'arrow-left',
  'arrow-rotate-right',
  'arrows-rotate',
  'arrows-to-dot',
  'backward',
  'bars',
  'bell',
  'calculator',
  'calendar',
  'calendar-week',
  'cart-circle-arrow-up',
  'cart-shopping',
  'cart-xmark',
  'chart-simple',
  'check',
  'check-double',
  'chevron-up',
  'circle',
  'circle-arrow-up-right',
  'circle-check',
  'circle-info',
  'circle-sharp-solid',
  'circle-xmark',
  'clipboard',
  'clock',
  'comments',
  'copyright',
  'credit-card',
  'download',
  'earth-americas',
  'ellipsis-vertical',
  'envelope',
  'envelope-open',
  'eye',
  'eye-slash',
  'file-invoice',
  'filter',
  'filter-slash',
  'floppy-disk',
  'forward',
  'gears',
  'grip-vertical',
  'info',
  'key',
  'left',
  'list',
  'location-dot',
  'lock-keyhole',
  'lock-keyhole-open',
  'mailbox-flag-up',
  'map',
  'message-plus',
  'messages',
  'mobile',
  'money-bill-transfer',
  'money-bill-wave',
  'note',
  'note-circle-plus',
  'paper-plane',
  'pen',
  'people-group',
  'person-running-tree',
  'play',
  'plus',
  'print',
  'question',
  'reply',
  'right',
  'right-from-bracket',
  'right-to-bracket',
  'rotate-left',
  'route',
  'route-arrows-rotate',
  'screwdriver-wrench',
  'shield-user',
  'sign-post',
  'signs-post',
  'sort-down',
  'sort-up',
  'square',
  'square-sharp-solid',
  'steering-wheel',
  'table',
  'toggle-off',
  'toggle-on',
  'traffic-cone',
  'trash',
  'tree',
  'tree-circle-plus',
  'tree-user',
  'trees',
  'triangle-exclamation',
  'truck',
  'truck-ramp-trees',
  'upload',
  'users-gear',
  'user-crown',
  'user',
  'user-admin',
  'user-collector',
  'user-controller',
  'user-driver',
  'user-manager',
  'user-officer',
  'user-planner',
  'user-team',
  'user-teamboard',
  'user-helmet-safety',
  'window-maximize',
  'xmark',
] as const;
